import React, { useState, useEffect } from "react";
import { useParams, useNavigate} from "react-router-dom";
import Header from "../../component/Header";
import api from "../../Services/api";
import { useSwal } from "../../component/sweetalert";

export default function EditNewlicence() {
  const { id } = useParams(); // Get Licence ID from URL
  const navigate = useNavigate(); // For navigation after update
  const alert = useSwal();

  // State to hold form data
  const [formData, setFormData] = useState({
    country: "",
    product_name: "",
    price: "",
  });

  // Fetch existing licence data when component mounts
  useEffect(() => {
    const fetchLicences = async () => {
      try {
        const response = await api.post(`/GetLicence/${id}`); // Use GET request
        setFormData({
          country: response.data.licence.country, // Fix response structure
          product_name: response.data.licence.product_name,
          price: response.data.licence.price,
        });
      } catch (error) {
        console.error("❌ Error fetching licence:", error);
        alert("error", "Failed to fetch licence details");
      }
    };
  
    if (id) {
      fetchLicences();
    }
  }, [id, alert]);
  
  // Handle input changes
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Handle form submission (update licence)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post(`/EditLicences/${id}`, formData);
      
      alert("success", "Licence updated successfully!");
      navigate("/new-licence"); // Redirect after update
    } catch (error) {
      console.error("❌ Error updating licence:", error);
      alert("error", "Failed to update licence details");
    }
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Edit New License Details" backTo="/new-licence" />
      <div className="pageLeftspace">
        {/* Back to Licences Link */}    
        <div className="d-flex justify-content-start col-xl-6 col-12">
        <form className="form-fields d-flex" onSubmit={handleSubmit}>
          <div className="grid-container user">
            {/* Country Input */}
            <div className="input-container">
              <input
                type="text"
                id="country"
                name="country"
                placeholder="Enter Country Name"
                value={formData.country}
                onChange={handleChange}
                required
                disabled
              />
              {/* <label htmlFor="country">Country Name</label> */}
              <span className="underline"></span>
            </div>

            {/* Product Name Input */}
            <div className="input-container">
              <input
                type="text"
                id="product_name"
                name="product_name"
                placeholder="Enter Product Name"
                value={formData.product_name}
                onChange={handleChange}
                required
                disabled
              />
              {/* <label htmlFor="product_name">Product Name</label> */}
              <span className="underline"></span>
            </div>

            {/* Price Input */}
            <div className="input-container">
              <input
                type="text"
                id="price"
                name="price"
                placeholder="Enter Price"
                value={formData.price}
                onChange={handleChange}
                required
              />
              {/* <label htmlFor="price">Price</label> */}
              <span className="underline"></span>
            </div>
            <button className="btn btn-purpal" type="submit">
              Update
            </button>
          
          </div>

          {/* Submit Button */}
      
        </form>
        </div>
      </div>
    </section>
  );
}
